import styled from 'styled-components';

export const NoContent = styled('div')`
${({ theme }) => `
    color: ${theme.colors.blueGrey3};
    margin-top: ${theme.spacing.px25};
`}`;

export const StrongParagraph = styled('strong')``;
